/* Pre-order support for the product page.

   snippets/product-preorder-map.liquid prints the ids of the product's
   pre-order variants plus the button label and ship message. This file:
   - switches the add-to-cart button text to "Pre-order" when a pre-order size
     is selected (the theme resets it to "Add to cart" on every size change),
   - enables/disables the persistent "Pre-order" property input (rendered in
     the product form by the snippet) whenever the size changes, so whatever
     reads the form - the theme, REZ Preorder, the AOV cart drawer - includes
     the property. A capture-phase submit listener re-syncs it as a safety net. */

(function () {
  if (window.__preorderInit) return;
  window.__preorderInit = true;

  function syncInput(formId, variantId) {
    var input = document.querySelector('input[data-preorder-input="' + formId + '"]');
    var map = getMap(formId);
    if (!input || !map) return;
    var id = variantId ? String(variantId) : currentVariantId(document.getElementById(formId));
    input.disabled = map.ids.indexOf(id) === -1;
    input.value = map.ship;
  }

  function getMap(formId) {
    var el = document.querySelector('script[data-preorder-map="' + formId + '"]');
    if (!el) return null;
    try {
      var data = JSON.parse(el.textContent);
      data.ids = (data.ids || []).map(String);
      return data;
    } catch (e) {
      return null;
    }
  }

  function currentVariantId(form) {
    var input = form && form.querySelector('[name="id"]');
    return input ? String(input.value) : '';
  }

  function applyButton(sectionId, variantId) {
    var formId = 'product-form-' + sectionId;
    var map = getMap(formId);
    var button = document.getElementById('ProductSubmitButton-' + sectionId);
    if (!map || !button) return;

    var label = button.querySelector('span');
    var id = variantId ? String(variantId) : currentVariantId(document.getElementById(formId));
    var isPreorder = map.ids.indexOf(id) !== -1 && !button.hasAttribute('disabled');
    syncInput(formId, id);

    if (isPreorder) {
      button.setAttribute('data-preorder', 'true');
      if (label) label.textContent = map.label;
    } else {
      button.removeAttribute('data-preorder');
      if (label && label.textContent.trim() === map.label && !button.hasAttribute('disabled')) {
        label.textContent = (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
      }
    }
  }

  function init() {
    document.querySelectorAll('script[data-preorder-map]').forEach(function (el) {
      var sectionId = el.getAttribute('data-preorder-map').replace('product-form-', '');
      applyButton(sectionId);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var data = event && event.data;
        if (!data || !data.sectionId) return;
        applyButton(data.sectionId, data.variant && data.variant.id);
      });
    }
  }

  /* Size change: the theme sets the form's variant id input and fires change. */
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || input.name !== 'id' || !input.form || input.form.id.indexOf('product-form-') !== 0) return;
    syncInput(input.form.id, input.value);
  });

  /* Safety net right before any add-to-cart reads the form. */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (form && form.id && form.id.indexOf('product-form-') === 0) syncInput(form.id);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
